export default __webpack_public_path__ + "img/img_nura-6cb6b8144b02bd599adff6028491bc53.jpg";